module.exports = __webpack_public_path__ + "static/frontend-standard-rich-text-editor-by-quill-9a9771f0377b13663052636ad054ac35.png";